<template>
  <v-app>
    <Navbar
      ref="navbar_comp"
      v-show="show_navbar"
      :primaryColor="primaryColor"
      v-if="$route.path != '/login' && $route.path != '/course/quizWeb'"
    />
    <!--  -->
    <v-main class="bg">
      <router-view
        @toggleNavBarCall="toggleNavBarCall"
        style="padding-top: 1rem !important; padding-left: 1.6rem !important"
        :primaryColor="primaryColor"
      ></router-view>
    </v-main>
     <BlockOverlay :show="secureMode" />
  </v-app>
</template>

<style scoped lang="css">
.bg {
  background: url("~@/assets/Component 87 – 6@2x.png") no-repeat center center;
  background-size: cover;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffff;
  transform: scale(1);
}
</style>

<script>
import Navbar from "./components/Navbar";
import BlockOverlay from "./components/BlockOverlay.vue";
import html2canvas from "html2canvas";
import axios from "axios";
export default {
  name: "App",

  components: {
    Navbar,
    BlockOverlay
  },

  data: () => ({
    //
    show_navbar: false,
    notiCount: 0,
    primaryColor: "#A6CC39",
    secureMode: false,
    sessionHeartbeatTimer: null, // F06 DSD
    heartbeatPending: false, // F06 DSD
  }),

  mounted() {
  globalThis.addEventListener('keyup', this.handlePrintScreen);
  // F06 DSD — heartbeat session ทุก 60 วินาที (D13) + ครั้งแรกหลัง router พร้อม (route แรกยังเป็น "/" ก่อน onReady)
  this.sessionHeartbeatTimer = setInterval(this.sessionHeartbeat, 60000);
  this.$router.onReady(() => this.sessionHeartbeat());
},
beforeDestroy() {
  globalThis.removeEventListener('keyup', this.handlePrintScreen);
  clearInterval(this.sessionHeartbeatTimer); // F06 DSD
  this.sessionHeartbeatTimer = null;
},
  methods: {
    toggleNavBarCall(v) {
      if (v == "userLogIn") {
        this.show_navbar = true;
      } else {
        this.show_navbar = false;
      }
    },
     async  handlePrintScreen(e) {
    if (e.key === "PrintScreen") {
      if (document.fullscreenElement) {
    await document.exitFullscreen();
  }
      this.secureMode = true;
         await this.$nextTick();
         setTimeout(() => {
    html2canvas(document.body).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "blocked.png";
      link.click();

      this.secureMode = false;
    });
  }, 300);
    }
  },
    // F06 DSD — heartbeat / resume session (A2, T5, T8) · ไม่ throw
    async sessionHeartbeat() {
      const path = (this.$route.path || "").toLowerCase();
      if (!sessionStorage.getItem("token") || path === "/login" || path === "/course/quizweb") return; // E7, T10
      if (this.heartbeatPending) return;
      // เครื่องตื่นจากหลับเกินเวลา idle → ไม่ส่ง heartbeat (Navbar จะ logout(2) และ server ใช้ LastSeenAt ก่อนหลับ — A8/A9)
      const shared = this.getSharedLastActivityAt();
      if (shared > 0 && Date.now() - shared >= this.getIdleConfig().timeoutMs) return;
      const sessionLogID = Number.parseInt(sessionStorage.getItem("sessionLogID"));
      const userID = Number.parseInt(sessionStorage.getItem("sessionUserID"));
      if (!sessionLogID || !userID) {
        sessionStorage.removeItem("sessionLogID");
        sessionStorage.removeItem("sessionUserID");
        await this.startUserSession(2); // ข้ามเองถ้ากำลังเริ่มอยู่ / ไม่มี UserID
        return;
      }
      this.heartbeatPending = true;
      try {
        const res = await axios.post(
          `${this.web_urlV7}UserSession/Heartbeat`,
          { userID, sessionLogID },
          { timeout: 15000 }
        );
        if (res.data.status != 0) {
          if (res.data.message === "SessionEnded" && sessionStorage.getItem("sessionLogID") === String(sessionLogID)) {
            sessionStorage.removeItem("sessionLogID");
            sessionStorage.removeItem("sessionUserID");
            this.startUserSession(2);
          } else {
            console.error(res.data.message);
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.heartbeatPending = false;
      }
    },
  },
};
</script>
